module.exports = __webpack_public_path__ + "img/MoroccanoilBody.5a38daf1.jpg";